import { render, staticRenderFns } from "./OnboardingRefactor.vue?vue&type=template&id=f66682ca&"
import script from "./OnboardingRefactor.vue?vue&type=script&lang=js&"
export * from "./OnboardingRefactor.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingRefactor.vue?vue&type=style&index=0&id=f66682ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports